export const STRAP_SIZE_KEY = 15
export const BUCKLE_KEY = 16
